export default __webpack_public_path__ + "static/media/imageVR.b4e49b5c.jpg";